import { BudgetSections } from 'business/constants';
import { useState } from 'react';

export const NO_SECTION = 'NO_SECTION';
type BudgetSectionsAndNoSection = BudgetSections | typeof NO_SECTION;

// Type for the state of exporters
type ExporterBySectionT = {
    [key in BudgetSectionsAndNoSection]: null | (() => void);
};

// Type for the function to set exporter
type SetExporterBySectionT = (
    exporter: null | (() => () => void),
    section?: BudgetSectionsAndNoSection,
) => void;

/**
 * Custom hook to manage exporters for different budget sections.
 * Provides state and function to set exporters for operating, investment, and no section.
 * @returns A tuple with the state object containing exporters and a function to set exporters.
 */
export const useExporterBySection = (): [
    ExporterBySectionT,
    SetExporterBySectionT,
] => {
    const [exporters, setExporters] = useState<ExporterBySectionT>({
        [BudgetSections.OPERATING]: null,
        [BudgetSections.INVESTMENT]: null,
        [NO_SECTION]: null,
    });

    const setExporterBySection = (
        exporter: null | (() => () => void),
        section: BudgetSectionsAndNoSection = NO_SECTION,
    ): void => {
        if (exporter)
            setExporters((prevExporters) => ({
                ...prevExporters,
                [section]: exporter(),
            }));
    };

    return [exporters, setExporterBySection];
};
